import { gql } from '@apollo/client';

const appraiserEventFieldsFragment = gql`
  fragment AppraiserEventFields on AppraiserEvent {
    Id
    AtlExternalUserId
    AtlName
    StartDate
    EndDate
    OrgUnitNames
    Stage
    DeliveryMethod
    WarningTypes
    IntendedEndDate
    IntendedStartDate
  }
`;

export default appraiserEventFieldsFragment;
